module.exports = __webpack_public_path__ + "img/three-dots.7627bc82.svg";